module.exports = __webpack_public_path__ + "static/media/pulse.cd4d55b2.svg";